import { lazy, Suspense } from 'react';
import Hero from '../components/Hero';
import { useSEO } from '../lib/useSEO';

// Only Hero loads eagerly (above the fold). Everything else is lazy.
const StatsSection       = lazy(() => import('../components/StatsSection'));
const MarqueeSection     = lazy(() => import('../components/MarqueeSection'));
const ServiceCard        = lazy(() => import('../components/ServiceCard'));
const ProcessSection     = lazy(() => import('../components/ProcessSection'));
const PortfolioSection   = lazy(() => import('../components/PortfolioSection'));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection'));
const WhyUsSection       = lazy(() => import('../components/WhyUsSection'));
const TechStackSection   = lazy(() => import('../components/TechStackSection'));
const CTASection         = lazy(() => import('../components/CTASection'));
const SectionDivider     = lazy(() => import('../components/SectionDivider'));

export default function LandingPage() {
  useSEO({
    title: 'SaaS & Web App Development Company India',
    description: 'Matchless Digital Hub builds custom SaaS platforms, CRM, ERP systems and web apps for startups and enterprises across India. Mumbai & Delhi. Free consultation.',
    keywords: 'SaaS development India, web app development, software development company India, CRM development, ERP solutions, custom software development, startup product development, Mumbai, Delhi',
    canonical: '/',
    schema: { type: 'Organization' },
  });

  return (
    <>
      <Hero />

      <Suspense fallback={null}>
        <StatsSection />

        <MarqueeSection />

        <ServiceCard compact />

        <SectionDivider variant="diamond" />

        <ProcessSection />

        <SectionDivider variant="gradient" />

        <PortfolioSection compact />

        <TestimonialsSection />

        <SectionDivider variant="dots" />

        <WhyUsSection />

        <SectionDivider variant="gradient" />

        <TechStackSection />

        <SectionDivider variant="line" />

        <CTASection />
      </Suspense>
    </>
  );
}
